


















import {Component, Prop, Vue} from 'vue-property-decorator'
import {Loan} from "@/model/loan";
import {supportService} from "@/services/support";

@Component
export default class MsisdnLoan extends Vue {

  @Prop()
  msisdn!: string

  loading = false

  region = 1
  regionOptions = [{
    'text': 'Local currency',
    'value': 1
  }, {
    'text': 'USD',
    'value': 3
  }]

  loan: Loan | null = null;

  async mounted() {
    await this.updateItem();
  }

  async updateItem() {
    this.loading = true;
    this.loan = await supportService.getLoan(this.msisdn,this.region);
    console.log('Hello')
    this.loading = false;
  }

}
